<template>
    <div id="wxindex">
        <video id="playerH5" controls="controls" webkit-playsinline width="100%" height="100%" loop="loop" autoplay="true">
            <source :src="videourl" type="video/mp4">
        </video>
        <div style="padding-bottom:60px;">
            <div class="video_replyTitle">
                <span class="video_replyNum">大家评论 {{replyNum}}</span>
                <el-select v-model="value" placeholder="请选择" @change="changeSelect">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="video_reply" v-for="item in applyList" :key="item.id">
                <div>
                    <img src="@/assets/img/background.jpg" alt="" style="width: 40px; height: 40px;border-radius:50%;">
                </div>
                <div class="video_flex"> 
                    <div class="video_replyDetail">
                        <div class="replyDetail_use">
                            <span class="replyDetail_userName">{{item.userName}}</span>
                            <span style="color:red;font-size:16px" @click="deleteApply(item.id)">删除</span>
                        </div>
                        <span class="replyDetail_content">{{item.content}}</span>
                        <div class="video_replyUse">
                            <div class="video_clickanswer" @click="answerApply(item)">
                                <img src="@/assets/img/answer.png" style="width: 18px; height: 16px;vertical-align:middle;" alt="">
                                <span style="margin-left:4px;font-size:12px;">回复</span>
                            </div>
                            <span class="replyDetail_time">{{item.commentTimeStr}}</span>
                        </div>
                    </div>
                    <div>
                        <div class="video_replyAnswer" v-for="answerItem in item.commentList" :key="answerItem.id">
                            <div style="margin-right:10px;">
                                <img src="@/assets/img/background.jpg" alt="" style="width: 25px; height: 25px;border-radius:50%;">
                            </div>
                            <div class="video_replyDetail">
                                <div  class="video_replyDetail_answerDetail">
                                    <div>
                                        <span class="replyDetail_userName">{{answerItem.userName}}</span>
                                        <span class="replyDetail_answerName"> 回复 {{answerItem.reviewersName}}：</span>
                                    </div>
                                    <span style="color:red;font-size:16px;" @click="deleteApply(answerItem.id)">删除</span>
                                </div>
                                <span class="replyDetail_content">{{answerItem.content}}</span>
                                <div class="video_replyUse">
                                    <div class="video_clickanswer">
                                        <div @click="answerApply(answerItem)">
                                            <img src="@/assets/img/answer.png" style="width: 18px; height: 16px;vertical-align:middle;" alt="">
                                            <span style="line-height: 20px;margin-left:6rpx;font-size:12px;">回复</span>
                                        </div>
                                    </div>
                                    <span class="replyDetail_time">{{answerItem.commentTimeStr}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="video_replying">
            <el-input style="width:80%;margin-left:20px;" class="video_input" v-model="content" :placeholder="inputPlaceholder" ref="inputVal" @blur="inputBlur"></el-input>
            <span class="input_submit" @click="onsure">发布</span>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            //评论数量
            replyNum:0,
            videourl:'',
            // 下拉选择框默认选中
            value:0,
            options: [
                {
                    value: 0,
                    label: '按时间正序'
                }, {
                    value: 1,
                    label: '按时间倒序'
            }],
            videoId:'',
            axiosValue:{
                token:'',
                factory_id:'',
                route:'',
                auth_Code:''
            },
            // 评论列表
            applyList:[],
            // 被评论的内容
            content:'',
            //点击回复时，被评论的内容信息
            applyInfo:'',
            inputPlaceholder:'请输入评论内容'
        }
    },
    created(){
        var searchUrl = window.location.search.split("?")[1].split("&")
        this.videourl = decodeURIComponent(searchUrl[0].split("=")[1]).split('"')[1]
        this.videoId = searchUrl[1].split("=")[1]
        this.axiosValue.token = searchUrl[2].split("=")[1]
        this.axiosValue.factory_id = searchUrl[3].split("=")[1]
        this.axiosValue.route = searchUrl[4].split("=")[1]
        this.axiosValue.auth_Code = searchUrl[5].split("=")[1]
        this.$store.commit('axiosValue',this.axiosValue)
        this.getApplyList()
    },
    methods:{
        // 获取评论列表
        getApplyList(){
            let _this = this
            this.axios({
                method: 'get',
                url: '/url/comment/list',
                params:{
                    sort: _this.value,
                    videoId: _this.videoId,
                    isApp: true,
                }
            }).then(function(res){
                if(res.data.success === 'true'){
                    _this.applyList = res.data.list
                    _this.replyNum = res.data.list.length
                }
            })
        },
        // 删除评论
        deleteApply(id){
            let _this = this
            this.axios({
                method:'get',
                url:'/url/comment/delete',
                params:{
                    id:id,
                    isApp:true
                }
            }).then(res=>{
                if(res.data.success === 'true'){
                    this.getApplyList()
                }
            })
        },
        // 切换选中的值
        changeSelect(){
            this.getApplyList()
        },
        // 发布评论
        onsure(){
            let _this = this
            let param = {}
            if(_this.applyInfo.length == 0){
                param={
                    content:_this.content,
                    videoId:_this.videoId,
                    isApp:true
                }
            }else if(_this.applyInfo.parentId===0){
                param={
                    content:_this.content,
                    videoId:_this.videoId,
                    parentId:_this.applyInfo.id,
                    userId:_this.applyInfo.userId,
                    userName:_this.applyInfo.userName,
                    isApp:true
                }
            }else{
                param={
                    content:_this.content,
                    videoId:_this.videoId,
                    parentId:_this.applyInfo.parentId,
                    userId:_this.applyInfo.userId,
                    userName:_this.applyInfo.userName,
                    isApp:true
                }
            }
            _this.axios({
                url:'/url/comment/add',
                method:'POST',
                params:param
            }).then(res=>{
                console.log(res)
                if(res.data.success === 'true'){
                    this.content=''
                    this.applyInfo=''
                    this.getApplyList()
                }
            })
        },
        answerApply(item){
            this.applyInfo=item
            this.$refs.inputVal.focus()
            this.inputPlaceholder='回复'+item.userName
        },
        inputBlur(){
            this.inputPlaceholder='请输入评论内容'
        }
    }
}
</script>

<style scoped>
    .video_replyNum{
        font-size:14px;
    }
    .video_replyTitle{
        padding:10px 10px;
        display:flex;
        justify-content: space-between;
        align-items: center;
    }
    .video_reply{
        padding:10px 10px;
        display:flex;
        border-bottom: 1px solid #e5e5e5;
        justify-content: space-between;
    }
    .video_flex{
        display:flex;
        flex-direction: column;
        width:85%;
    }
    .replyDetail_use{
        display:flex;
        justify-content: space-between;
        align-items: center;
    }
    .replyDetail_userName{
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10rpx;
        letter-spacing: 1rpx;
    }
    .replyDetail_content{
        font-size:14px;
        line-height: 50rpx;
        letter-spacing: 1rpx;
        margin:6px 0;
    }
    .replyDetail_time{
        font-size:12px;
    }
    .video_replyUse{
        display:flex;
        justify-content: space-between;
        align-items: center;
        color: #a4a9ae;
    }
    .video_replying{
        width:100%;
        background:#fff;
        position:fixed;
        bottom:0;
        border-top: 1px solid #F0F0F0;
        display:flex;
        justify-content:space-between;
        align-items: center;
        padding:10px 0;
    }
    .video_replying .el-input__inner{
        background:#F2F2F5;
    }
    .video_input{
        border-radius:20%;
    }
    .input_submit{
        font-size: 14px;
        color: #2979ff;
        margin-right:20px;
    }
    .video_replyAnswer{
        display: flex;
        flex-direction: row;
        border-top:1rpx solid #e5e5e5; 
        padding-top:20rpx;
    }
    .video_replyDetail_answerDetail{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .replyDetail_answerName{
        font-size: 14px;
        color: #a4a9ae;
        letter-spacing: 1rpx;
        margin-left: 10rpx;
    }
    .video_replyAnswer .video_replyDetail{
        width:100%;
    }
</style>